// biome-ignore-all lint/style/useNamingConvention: exisiting error

export const defaultTemplatePreviewConfig = {
  artist: null,
  assets: {
    default: {
      _hash: '2ea7d4eb7f4698842d71c92542693244',
      '500x680':
        '//storage.googleapis.com/images.test.evite.com/premium_assets/fabric_gallery_asset/1748377382/template_thumbnail_6196447069372416_default_500x680.png',
      '500x680_optimized':
        '//storage.googleapis.com/images.test.evite.com/premium_assets/fabric_gallery_asset/1748377382/template_thumbnail_optimized_6196447069372416_default_500x680_optimized.webp',
      '600x600':
        '//storage.googleapis.com/images.test.evite.com/premium_assets/fabric_gallery_asset/1755130974/composed_thumbnail_5122855101038592_default_600x600.webp',
      '250x340':
        '//storage.googleapis.com/images.test.evite.com/premium_assets/fabric_gallery_asset/1748377382/template_thumbnail_6196447069372416_default_250x340.png',
      '250x340_optimized':
        '//storage.googleapis.com/images.test.evite.com/premium_assets/fabric_gallery_asset/1748377383/template_thumbnail_optimized_6196447069372416_default_250x340_optimized.webp',
      '372x372':
        '//storage.googleapis.com/images.test.evite.com/premium_assets/fabric_gallery_asset/1755130973/composed_thumbnail_5122855101038592_default_372x372.webp',
      medium_gallery_asset:
        '//storage.googleapis.com/images.test.evite.com/premium_assets/fabric_gallery_asset/1755130974/template_thumbnail_5122855101038592_default_medium_gallery_asset.webp',
      small_gallery_asset:
        '//storage.googleapis.com/images.test.evite.com/premium_assets/fabric_gallery_asset/1755130973/template_thumbnail_5122855101038592_default_small_gallery_asset.webp',
    },
  },
  displayName: 'Disney’s Lilo & Stitch: Somewhere Sandy',
  eventTitleColor: null,
  informationColor: null,
  eventType: 'birthday_forkids',
  keywords: [
    'Birthday',
    'birthday party',
    "kids' birthday",
    "kid's birthday",
    'birthday for kids',
    'character',
    'disney',
    'lilo',
    'lilo and stitch',
    'stitch',
    'beach',
    'pool',
    'tropical',
    'summer',
    'outdoor',
    'six',
    'sixth birthday',
    '6',
    '6th birthday',
  ],
  altTag: null,
  templateId: 'disney-0147-liloandstitch-somewhere-sandy',
  uyo: false,
  dyo: false,
  categories: [
    'disney',
    'kids_beach_party',
    'kids_outdoor_fun',
    'featured',
    'kids_teens_birthday_milestones',
    'characters',
    'kids_summer_parties',
    'birthday_forkids',
    '6th_birthday',
    'birthday',
    'kids_and_teens',
  ],
  colors: ['blue', 'white', 'yellow', 'green'],
  popularity: 0.06141522029372497,
  premium: true,
  metaDescription: null,
  invitationTypes: null,
  favorite: false,
  usedAs: 'invitation',
  badge: null,
  uyoImagePosition: {},
  templatePositionPercent: {
    left: 35.2,
    top: 12.6,
    height: 74.8,
    width: 55,
  },
  // 3 across A/B test variant
  templatePositionPercentVariant: {
    left: 28.22,
    top: 10.36,
    height: 79.35,
    width: 43.8,
  },
  width: 1000,
  height: 1360,
};
